// // helpers/dateHelpers.js
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { renderAlert } from '../../../CommonComponents/Alert/Alert';

dayjs.extend(customParseFormat);

const formats = [
    // Day-Month-Year variations
    "D MMM",
    "D MMM YY",    // 2-digit
    "D MMM YYYY",  // 4-digit

    "DD MMM",
    "DD MMM YY",
    "DD MM YYYY",
    "DD MMM YYYY",

    "D MMMM",
    "D MMMM YY",
    "D MMMM YYYY",

    "DD MMMM",
    "DD MMMM YY",
    "DD MMMM YYYY",

    // Month-Day-Year variations
    "MMM D",
    "MMM D YY",
    "MMM D YYYY",

    "MMM DD",
    "MMM DD YY",
    "MMM DD YYYY",

    "MMMM D",
    "MMMM D YY",
    "MMMM D YYYY",

    "MMMM DD",
    "MMMM DD YY",
    "MMMM DD YYYY",

    // Numeric formats
    "M/D",     
    "M/D/YY",
    "M/D/YYYY",

    "MM/DD",
    "MM/DD/YY",
    "MM/DD/YYYY",

    "M-D",
    "M-D-YY",
    "M-D-YYYY",

    "MM-DD",
    "MM-DD-YY",
    "MM-DD-YYYY",
];

export const processDate = (value, valueChangeByOnCellValueChange) => {
    if (!value) return value;

    value = value.trim();

    // Convert month names to title case to match dayjs parsing
    const normalizeMonth = (str) => str.replace(
        /\b([a-z]+)/gi,
        (match) => match.charAt(0).toUpperCase() + match.slice(1).toLowerCase()
    );

    value = normalizeMonth(value);

    // Try parsing with known formats
    let parsed = null;
    for (const format of formats) {
        const d = dayjs(value, format, true); // strict parsing
        if (d.isValid()) {
            parsed = d;
            break;
        }

    }

    if (!parsed) {
        if (!valueChangeByOnCellValueChange) {
            renderAlert("Invalid date entered", "error");
        }
        return null;
    }
    let year = parsed.year();

    //  Fix: normalize year digits
    if (year < 100) {
        // 1-digit and 2-digit years → 2000 + year
        year = 2000 + year;
    } else if (year < 1000) {
        // 3-digit years → treat as 2000+ but keep century aligned
        year = 2000 + year; // 234 → 2234
    }

    // If year is missing, default to current year
    if (!/(\d{2,4})/.test(value)) {
        year = dayjs().year();
    }

    const month = parsed.month() + 1; // month() is 0-based
    const day = parsed.date();

    // Final validation
    if (year < 1900 || year > 2099 || month < 1 || month > 12 || day < 1 || day > 31) {
        if (!valueChangeByOnCellValueChange) {
            renderAlert("Invalid date entered", "error");
        }
        return null;
    }

    return `${String(month).padStart(2, "0")}/${String(day).padStart(2, "0")}/${year}`;
};
